"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadingSpinner = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _colors = require("../core/colors");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var SPINNER_SIZES = Object.freeze({
  small: '3px',
  medium: '6px',
  large: '20px'
});
var rotateAnimation = (0, _styledComponents.keyframes)(["0%{-webkit-transform:rotate(0deg);transform:rotate(0deg);}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg);}"]);
var StyledDiv = _styledComponents["default"].div.withConfig({
  displayName: "loading-spinner__StyledDiv"
})(["display:flex;position:relative;text-indent:-9999em;transform:translateZ(0);font-size:", ";animation:", " 1.1s linear infinite;border-top:0.5em solid ", ";border-right:0.5em solid ", ";border-bottom:0.5em solid ", ";border-left:0.5em solid ", ";&,&:after{border-radius:50%;width:5em;height:5em;}"], function (props) {
  return SPINNER_SIZES[props.$size];
}, rotateAnimation, _colors.COLORS.white, _colors.COLORS.gray, _colors.COLORS.gray, _colors.COLORS.white);
var LoadingSpinner = exports.LoadingSpinner = function LoadingSpinner(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'large' : _ref$size;
  return /*#__PURE__*/_react["default"].createElement(StyledDiv, {
    $size: size
  });
};